/* unplugin-vue-components disabled */import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.exec.js";
import { defineComponent as _defineComponent } from 'vue';
import AdvancedLoginForm from '@/components/login-form/advanced.vue';
import RegisterPrivacyCheckbox from '@/components/register-privacy-checkbox.vue';
import { Toast } from 'vant';
export default /*#__PURE__*/ _defineComponent({
    __name: 'login',
    setup: function(__props) {
        var router = useRouter();
        var form = ref();
        var agreed = ref(false);
        function onLoginFinished() {
            Toast({
                message: 'Login successfully',
                duration: 3000
            });
            router.replace('/');
        }
        return {
            __sfc: true,
            router: router,
            form: form,
            agreed: agreed,
            onLoginFinished: onLoginFinished,
            AdvancedLoginForm: AdvancedLoginForm,
            RegisterPrivacyCheckbox: RegisterPrivacyCheckbox
        };
    }
});
